module.exports = __webpack_public_path__ + "static/media/bur1 (2).17cd4a51.jpeg";